 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["TurnToWpJsonp"];
 	window["TurnToWpJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};
 	var Promise;
 	if (typeof window['Promise'] === 'function' && /native code/.test(window['Promise']).toString()) {
 		Promise = window['Promise'];
 	} else {
 		Promise = function BootPromise(callback, handler) {
 		  var func = 'f'
 		  var obj = 'o'
 		  function is(type, item) { return (typeof item)[0] == type; }
 		  // Finalizes the promise by resolving/rejecting it with the transformed value
 		  function finalize(promise, resolve, reject, value, transform) {
 		    setImmediate(function () {
 		      try {
 		        // Transform the value through and check whether it's a promise
 		        value = transform(value);
 		        transform = value && (is(obj, value) | is(func, value)) && value.then;
 		        // Return the result if it's not a promise
 		        if (!is(func, transform))
 		          resolve(value);
 		        // If it's a promise, make sure it's not circular
 		        else if (value == promise)
 		          reject(TypeError());
 		        // Take over the promise's state
 		        else
 		          transform.call(value, resolve, reject);
 		      }
 		      catch (error) { reject(error); }
 		    });
 		  }

 		  // The `handler` variable points to the function that will
 		  // 1) handle a .then(resolved, rejected) call
 		  // 2) handle a resolve or reject call (if the first argument === `is`)
 		  // Before 2), `handler` holds a queue of callbacks.
 		  // After 2), `handler` is a finalized .then handler.
 		  handler = function pendingHandler(resolved, rejected, value, queue, then, i) {
 		    queue = pendingHandler.q;

 		    // Case 1) handle a .then(resolved, rejected) call
 		    if (resolved != is) {
 		      return Promise(function (resolve, reject) {
 		        queue.push({ p: this, r: resolve, j: reject, 1: resolved, 0: rejected });
 		      });
 		    }

 		    // Case 2) handle a resolve or reject call
 		    // (`resolved` === `is` acts as a sentinel)
 		    // The actual function signature is
 		    // .re[ject|solve](<is>, success, value)

 		    // Check if the value is a promise and try to obtain its `then` method
 		    if (value && (is(func, value) | is(obj, value))) {
 		      try { then = value.then; }
 		      catch (reason) { rejected = 0; value = reason; }
 		    }
 		    // If the value is a promise, take over its state
 		    if (is(func, then)) {
 		      try { then.call(value, transferState(1), rejected = transferState(0)); }
 		      catch (reason) { rejected(reason); }
 		    }
 		    // The value is not a promise; handle resolve/reject
 		    else {
 		      // Replace this handler with a finalized resolved/rejected handler
 		      handler = function (Resolved, Rejected) {
 		        // If the Resolved or Rejected parameter is not a function,
 		        // return the original promise (now stored in the `callback` variable)
 		        if (!is(func, (Resolved = rejected ? Resolved : Rejected)))
 		          return callback;
 		        // Otherwise, return a finalized promise, transforming the value with the function
 		        return Promise(function (resolve, reject) { finalize(this, resolve, reject, value, Resolved); });
 		      };
 		      // Resolve/reject pending callbacks
 		      i = 0;
 		      while (i < queue.length) {
 		        then = queue[i++];
 		        // If no callback, just resolve/reject the promise
 		        if (!is(func, resolved = then[rejected]))
 		          (rejected ? then.r : then.j)(value);
 		        // Otherwise, resolve/reject the promise with the result of the callback
 		        else
 		          finalize(then.p, then.r, then.j, value, resolved);
 		      }
 		    }
 		    // Returns a function that transfers the state of the promise
 		    function transferState(resolved) {
 		      return function (value) { then && (then = 0, pendingHandler(is, resolved, value)); };
 		    }
 		  };
 		  // The queue of pending callbacks; garbage-collected when handler is resolved/rejected
 		  handler.q = [];

 		  // Create and return the promise (reusing the callback variable)
 		  callback.call(callback = { then:    function (resolved, rejected) { return handler(resolved, rejected); },
 		                             "catch": function (rejected)           { return handler(0,        rejected); } },
 		                function (value)  { handler(is, 1,  value); },
 		                function (reason) { handler(is, 0, reason); });
 		  return callback;
 		}
 	}

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		23: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "Pk4jeZvHFwjKClIsite/js/" + ({"0":"expired-confirmation","1":"submission","2":"registration-modal","3":"media-modal","4":"profile","5":"cc-widget","6":"multi-item-search","7":"ask-results","8":"spectrum","9":"pdp-page","10":"comments-pinboard-page","11":"comments-pinboard-teaser-page","12":"order-confirmation-page","13":"base","14":"dfp","15":"review-form","16":"solo-question","17":"add-captions","18":"share-media","19":"add-video","20":"seller-ratings","21":"registration","22":"do-more"}[chunkId]||chunkId) + "." + {"0":"68932d0964e412ccfcb8","1":"6abd59627c873b0141e1","2":"e4e3ed19a9fd4438abea","3":"0c5eeccc00b4d4e6dfee","4":"830424cc65764e8e3a4d","5":"7d45ccce5e181d916442","6":"38a78d85f31774dc3ec3","7":"9e40687d966604c8597d","8":"59c8aa59e90b2744e999","9":"b5358c35bbe572ae7e78","10":"567f0013a3404f4d1829","11":"349a28f62e1eec49bd20","12":"b437e6608edc2475851f","13":"cbed63dac5e7d01edc31","14":"fa1ca3308c976287eb59","15":"3c14c791b9442a0e30ec","16":"c8a7efdf5b9f261deef1","17":"095ee89e80dab8d2c481","18":"3a64e5aa1f7b4a91edf5","19":"aade52508d242b4c7e97","20":"2ced0afacb3d429990dd","21":"6e0e1526f7ea999c9cb9","22":"f5d0472a3f70942e7190"}[chunkId] + ".js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 156);



// WEBPACK FOOTER //
// webpack/bootstrap 2de0f7f5fe4a0050b7e8